export default __webpack_public_path__ + "34a42165c0d629637c25f6438fd6aab3.png";